"use client";
import {
  useHovercardHeading
} from "../__chunks/6N2ESJUH.js";
import "../__chunks/RJDEYIKS.js";
import "../__chunks/XHRZYRZ5.js";
import "../__chunks/P4FX6ZFL.js";
import "../__chunks/XPF5GU3Q.js";
import "../__chunks/G6BJYYBK.js";
import "../__chunks/OAYFXAQ2.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/3ORBWXWF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-heading.ts
var useMenuHeading = createHook((props) => {
  props = useHovercardHeading(props);
  return props;
});
var MenuHeading = createComponent((props) => {
  const htmlProps = useMenuHeading(props);
  return createElement("h1", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuHeading.displayName = "MenuHeading";
}
export {
  MenuHeading,
  useMenuHeading
};
